import BaseItem from "./BaseItem";
import baseItemRehydrator from "./BaseItem.rehydrator";
export default BaseItem;
export { baseItemRehydrator };